import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as l } from "../../../../IconBase-CxZyIWw2.js";
const o = t((c, e) => /* @__PURE__ */ s.jsx(
  l,
  {
    ref: e,
    ...c,
    image: (r) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...r,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_4161",
              width: 32,
              height: 32,
              x: 8,
              y: 8,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M15.37 9.5c.41 0 .75-.34.75-.75S15.78 8 15.37 8H8.75c-.41 0-.75.34-.75.75v13.24c0 .41.34.75.75.75s.75-.34.75-.75v-5.87h5.87c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H9.5V9.5zM15.37 26.76c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H8.75c-.41 0-.75.34-.75.75v13.23c0 .42.34.76.75.76s.75-.34.75-.75v-5.87h5.87c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H9.5v-5.12zM38.3 8H26.96c-.94 0-1.7.76-1.7 1.7v28.6c0 .2.08.39.22.53l.95.95c.14.14.33.22.53.22H38.3c.2 0 .39-.08.53-.22l.95-.95a.75.75 0 0 0 .22-.53V9.7c0-.94-.76-1.7-1.7-1.7M26.96 9.5H38.3c.11 0 .2.09.2.2v13.55H26.76V9.7c0-.11.09-.2.2-.2m11.03 29H27.27l-.51-.51V24.75H38.5v13.24z"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4161)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M.508-.294h46.715v49.412H.508z" }) })
        ]
      }
    )
  }
));
o.displayName = "AgencySuperbottleIcon";
export {
  o as AgencySuperbottleIcon,
  o as default
};
//# sourceMappingURL=index.js.map
